import TitledText from "@coworker/apprestructured/src/task-management/components/TitledText/TitledText";
import { getByPath } from "@coworker/apprestructured/src/shared/helpers/object.helper";
import { isLoading } from "@coworker/apprestructured/src/task-management/loading";
import { ViewerFragmentCommonProps } from "@coworker/apprestructured/src/task-management/components/TaskViewerSheet/viewer-fragments/ViewerFragment";
import { useTranslation } from "@coworker/locales";
import { getTypedValue } from "@coworker/apprestructured/src/shared/helpers/schemaValidator";

export type TitledTextFieldViewerFragmentConfigProps = {
  title: string;
  field: string;
  shouldTranslateText?: boolean;
  suffix?: string;
};

type TitledTextFieldViewerFragmentProps = {
  configProps: TitledTextFieldViewerFragmentConfigProps;
  commonProps: ViewerFragmentCommonProps;
};

function TitledTextFieldViewerFragment({
  configProps,
  commonProps,
}: TitledTextFieldViewerFragmentProps) {
  const { field, title, shouldTranslateText = false, suffix } = configProps;
  const { task } = commonProps;
  const text = getTypedValue<string>(getByPath(task, field));

  const { t } = useTranslation();

  if (isLoading(text) || text == null || String(text).length === 0) {
    return null;
  }

  const displayText = shouldTranslateText ? t(String(text)) : String(text);
  const textWithSuffix = suffix ? `${displayText} ${t(suffix)}` : displayText;

  return <TitledText title={t(title)} text={textWithSuffix} />;
}

export default TitledTextFieldViewerFragment;
